import type { Editor, EditorEvent } from 'hugerte';

export const deleteMedia = (event: EditorEvent<TouchEvent | MouseEvent | KeyboardEvent>, editor: Editor): void => {
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	const button = event.target as HTMLButtonElement;
	if (button.className === 'closer') {
		const parentInEditor = button.parentElement?.parentElement;
		if (parentInEditor) {
			parentInEditor.removeChild(button.parentElement);
			editor.selection.setNode(parentInEditor);
			editor.execCommand('mceInsertNewLine');
		}
	}
};
